import React, { Component } from "react";
import "./index.scss";

class Hero extends Component {
  render() {
    return (
      <section className="cover-photo">
        <div className="container">
          <div className="circle one" />
          <div className="circle two" />
          <div className="circle three" />
          <div className="circle four" />
          <div className="circle five" />
          <div className="text-wrapper">
            <h1 className="text">Mohamed Azazy</h1>
            <h2 className="text">UI/UX Designer</h2>
          </div>
        </div>
      </section>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/HomeContainer/Hero/index.jsx